import _ from "lodash";
import { getEanForColorAndSize } from "./products";

import { createCacheForPrice } from "../utils/createCacheForPrice";

export const getProductsPrices = (context) =>
  _.get(context, "entities.productsPrices");

export const getPriceType = (context) => _.get(context, "state.priceType");

const findPrice = ({
  productsPrices,
  ean,
  priceGroup,
  season,
  number,
  priceType,
}) => {
  const value = _.get(
    productsPrices,
    `${season}.${number}.${ean}.${priceGroup}.${priceType}`,
  );
  const currency = _.get(
    productsPrices,
    `${season}.${number}.${ean}.${priceGroup}.c`,
  );

  return { value, currency };
};

export const getPriceForEanAndGroup = ({
  context,
  ean,
  priceGroup,
  priceType = "u",
  number,
  season,
  withoutCaching,
}) => {
  const productsPrices = getProductsPrices(context);
  if (!productsPrices) return null;
  const value = findPrice({
    productsPrices,
    ean,
    priceGroup,
    season,
    number,
    priceType,
  });

  if (!withoutCaching) {
    context.actions.updateCacheForPrice({
      ean,
      priceGroup,
      value,
      priceType,
      number,
      season,
    });
  }
  return value;
};

export const getPriceFromCache = ({
  context,
  number,
  priceGroup,
  season,
  ean,
  priceType,
}) =>
  context.state.cacheForPrice[
    createCacheForPrice({
      season,
      number,
      ean,
      priceGroup,
      priceType: priceType || getPriceType(context),
    })
  ];

export const getPriceForColorAndSizeAndGroup = ({
  context,
  color,
  number,
  size,
  priceGroup,
  season,
  priceType,
  withoutCaching,
}) => {
  const ean = getEanForColorAndSize({
    number,
    context,
    color: color,
    size,
  });

  let price;
  if (!withoutCaching) {
    price = getPriceFromCache({
      context,
      ean,
      number,
      priceGroup,
      priceType,
      season,
    });
  }

  if (_.get(price, "value")) return price;

  return getPriceForEanAndGroup({
    context,
    ean,
    priceGroup,
    priceType: priceType || getPriceType(context),
    number,
    season,
    withoutCaching,
  });
};
